import { sortBy, forEach, filter } from 'lodash';

export function flattenComments(comments) {
    let commentsListWithoutHierarchy = [];
    forEach(comments, comment => {
        commentsListWithoutHierarchy.push(comment);
        if (comment.children) {
            commentsListWithoutHierarchy.push(...comment.children);
        }
    });
    return filter(commentsListWithoutHierarchy, ({ deleted }) => !deleted);
}

export function sortComments(comments) {
    return sortBy(comments, ({ created_at }) => {
        return -(new Date(created_at).getTime());
    });
}
